var render = function render(){var _vm=this,_c=_vm._self._c;return _c('report-section',{staticClass:"rr-frequency-section",attrs:{"title":"频谱图"},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"chart-container"},[_c('div',{staticClass:"frequency-chart",attrs:{"id":_vm.chartId}}),_c('div',{staticClass:"x-axis-label"},[_vm._v("(Hz)")])])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }